import '@atlassian/jira-vendor/src/vendor-parcel.tsx';
import '@atlassian/jira-vendor/src/commons-parcel.tsx';

import { classicSoftwareBoardRouteEntry } from '@atlassian/jira-router-routes-software-classic-board-entries/src/classicSoftwareBoardRouteEntry.tsx';
import { bootstrapSingleSpaRoute } from './bootstrap/single-spa-route.tsx';

bootstrapSingleSpaRoute(() => [classicSoftwareBoardRouteEntry]);
